import { Component } from '@angular/core';

@Component({
  selector: 'app-impressum-view',
  templateUrl: './impressum-view.component.html',
  styleUrls: ['./impressum-view.component.scss'],
  standalone: false
})
export class ImpressumViewComponent { }
